import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { NotificationFilters, TimeFilterValue } from "@/domain";

interface NotificationFiltersState {
	filters: NotificationFilters;
	timeFilter: TimeFilterValue;
	setFilterValue: <K extends keyof NotificationFilters>(
		key: K,
		value: NotificationFilters[K],
	) => void;
	setTimeFilter: (value: TimeFilterValue) => void;
	clearFilters: () => void;
}

const initialFilters: NotificationFilters = {};

export const useNotificationFiltersStore = create<NotificationFiltersState>()(
	devtools(
		(set) => ({
			filters: { ...initialFilters },
			timeFilter: "all",
			setFilterValue: (key, value) =>
				set((state) => ({
					filters: { ...state.filters, [key]: value },
				})),
			setTimeFilter: (value) =>
				set((state) => {
					let created_after: string | undefined;
					if (value === "this_week") {
						const d = new Date();
						d.setDate(d.getDate() - 7);
						created_after = d.toISOString();
					} else if (value === "this_month") {
						const d = new Date();
						d.setMonth(d.getMonth() - 1);
						created_after = d.toISOString();
					}
					return {
						timeFilter: value,
						filters: {
							...state.filters,
							created_after,
							created_before: undefined,
						},
					};
				}),
			clearFilters: () =>
				set({ filters: { ...initialFilters }, timeFilter: "all" }),
		}),
		{ name: "NotificationFiltersStore" },
	),
);
